import React, { useState, useEffect } from 'react';
import { getSignedUrl } from '../../lib/supabase';
import { UserCircle } from 'lucide-react';

const PrivateImage = ({ bucket, path, alt, className, fallbackIcon: FallbackIcon = UserCircle }) => {
  const [signedUrl, setSignedUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!path) {
      setLoading(false);
      return;
    }

    const fetchSignedUrl = async () => {
      try {
        setLoading(true);
        const url = await getSignedUrl(bucket, path);
        if (url) {
          setSignedUrl(url);
        } else {
          setError(true);
        }
      } catch (err) {
        console.error('Error cargando imagen:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchSignedUrl();
  }, [bucket, path]);

  if (loading) {
    return (
      <div className={`${className} bg-gray-200 animate-pulse flex items-center justify-center`}>
        <div className="w-8 h-8 border-2 border-gray-400 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (error || !signedUrl) {
    return (
      <div className={`${className} bg-gray-200 flex items-center justify-center`}>
        <FallbackIcon className="w-12 h-12 text-gray-400" />
      </div>
    );
  }

  return (
    <img 
      src={signedUrl} 
      alt={alt} 
      className={className}
      onError={() => setError(true)}
    />
  );
};

export default PrivateImage;